<template>
<div class="chapter">
<div class="inner_page">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="70%"/>
<col width="30%"/>
</colgroup><tbody><tr>
<td valign="top"><h2 class="h2"><a id="page_viii"></a><a id="page_ix"></a><span class="yellow">Contents</span></h2></td>
<td valign="top"><h2 class="h2a"><span class="yellow">C</span></h2></td>
</tr>
</tbody></table>
<p class="image"><img alt="Image" src="images/f0viii-01.jpg"/></p>
<p class="toc"><a href="#/xhtml/foreword#fore"><span class="yellow"><strong>Foreword</strong></span></a></p>
<p class="toc"><a href="#/xhtml/preface"><span class="yellow"><strong>Preface</strong></span></a></p>
<p class="toc"><a href="#/xhtml/acknowledgments"><span class="yellow"><strong>Acknowledgments</strong></span></a></p>
<p class="toca"><a href="#/xhtml/chapter01#ch01"><span class="yellow"><strong>1.</strong> What Is a Sabertooth?</span></a></p>
<p class="toc"><span href="#/xhtml/chapter02#ch02" title="Link target outside of Sample"><span class="yellow"><strong>2.</strong> The Ecology of Sabertooths</span></span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch03" title="Link target outside of Sample"><span class="yellow"><strong>3.</strong> A Who’s Who of Sabertoothed Predators</span></span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch04" title="Link target outside of Sample"><span class="yellow"><strong>4.</strong> Sabertooths as Living Predators</span></span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch05" title="Link target outside of Sample"><span class="yellow"><strong>5.</strong> Extinctions</span></span></p>
<p class="toca"><span href="#/xhtml/bibliography" title="Link target outside of Sample"><span class="yellow"><strong>Bibliography</strong></span></span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><span class="yellow"><strong>Index</strong></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f4b804f0